import { ImageNaturalDimension } from 'types/common_types';

export type BaseWallPreviewRoom = {
  id: string | number;
  type: 'sample' | 'user';
  description: string;
};

export type RawWallPreviewSampleRoom = BaseWallPreviewRoom & {
  id: string;
  type: 'sample';
  filename: string;
  wallSize: number;
  extraSpace: number;
};

export type RawWallPreviewUserRoom = BaseWallPreviewRoom & {
  id: number;
  type: 'user';
  customer_id: string;
  updated_at: string;
  created_at: string;
  wall_size: number;
  url: string;
};

type FormattedWallPreviewRoom = {
  previewSrc: string;
  fullSrc: string;
  displaySize: string;
  wallSize: number;
  extraSpace: number;
};

export type WallPreviewRoom = BaseWallPreviewRoom & FormattedWallPreviewRoom;
export type WallPreviewSampleRoom = RawWallPreviewSampleRoom & FormattedWallPreviewRoom;
export type WallPreviewUserRoom = RawWallPreviewUserRoom & FormattedWallPreviewRoom;
export type WallPreviewActiveRoom = WallPreviewRoom & { blobSrc?: string };

export type WallPreviewImageLoadPayload = ImageNaturalDimension & { blobSrc: string };

export type CreateUserRoomPOSTData = {
  url: string;
  filename: string;
  wall_size: number;
};

export type SaveUserRoomPUTData = {
  id: number;
  description: string;
  wall_size?: number;
};

export type EditUserRoomDraft = {
  id: number;
  description: string;
  wallSize: number;
  shouldUpdateWidth: boolean;
  lengthInput?: number;
  x1?: number;
  y1?: number;
  x2?: number;
  y2?: number;
};
